import { Skeleton, SkeletonButton, SkeletonCard } from 'shared/components/ui/Skeleton';

// Espelha <NextGameCard> + <ArenaList> (cabeçalho "Arenas perto de você" e 3 linhas).
export function PlayerHomeSkeleton() {
  return (
    <>
      <SkeletonCard className="mt-6">
        <div className="flex justify-between">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-3 w-12" />
        </div>
        <Skeleton className="mt-3 h-5 w-48" />
        <Skeleton className="mt-2 h-3 w-36" />
        <div className="mt-4 flex gap-3">
          <SkeletonButton className="flex-1" />
          <SkeletonButton className="flex-1" />
        </div>
      </SkeletonCard>

      <div className="mt-8">
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-44" />
          <Skeleton className="h-3 w-16" />
        </div>
        <div className="mt-4 flex flex-col gap-3">
          {Array.from({ length: 3 }, (_, index) => (
            <SkeletonCard key={index} className="flex items-center gap-4 p-4">
              <Skeleton className="h-10 w-10 flex-shrink-0 rounded-full" />
              <div className="flex-1">
                <Skeleton className="h-4 w-36" />
                <Skeleton className="mt-2 h-3 w-48" />
                <Skeleton className="mt-2 h-3 w-24" />
              </div>
            </SkeletonCard>
          ))}
        </div>
      </div>
    </>
  );
}
